export default __webpack_public_path__ + "static/media/icon_home_top_hand.4cdc92a0.svg";